export const columnHeadersSelector = ({ reports }) => reports.estimateSummary.columnHeaders;

export const isFetchingColumnHeadersSelector = ({ reports }) =>
  reports.estimateSummary.isFetchingColumnHeaders;
